<template>
  <div>
    <el-tabs v-model="obj.category" @tab-click="handleTabClick">
      <el-tab-pane label="自选" name="favorites"></el-tab-pane>
      <el-tab-pane label="主力" name="main"></el-tab-pane>
      <el-tab-pane label="上期所" name="shfe"></el-tab-pane>
      <el-tab-pane label="大商所" name="dce"></el-tab-pane>
      <el-tab-pane label="郑商所" name="czce"></el-tab-pane>
      <el-tab-pane label="上期能源" name="ine"></el-tab-pane>
      <el-tab-pane label="广期所" name="gfex"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="obj.categorySub" @tab-click="handleSubTabClick">
      <el-tab-pane v-for="data in obj.subTabDataList" :key="data" :label="data.label" :name="data.name"></el-tab-pane>
    </el-tabs>
    <div v-if="obj.category === 'favorites'">
      <el-button type="primary" @click="handleFavorites">
        <el-icon class="el-input__icon">
          <star />
        </el-icon>编辑自选
      </el-button>
    </div>
    <el-table :data="obj.dataList" style="width: 100%" height="100%" empty-text=""
      :style="'height:' + (store.state.windowHeight - 240) + 'px'" :cell-style="cellStyle" @row-click="handleRowClick">
      <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
      <el-table-column fixed label="名称" prop="name" width="140px" align="right" sortable />
      <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
      <el-table-column label="最新" prop="close" width="80px" align="right" />
      <el-table-column label="涨跌" prop="chg" width="80px" align="right" :sort-method="customStrSort" sortable />
      <el-table-column label="涨跌幅" prop="chgPct" width="90px" align="right" :sort-method="customPctSort" sortable />
      <el-table-column label="开盘" prop="open" width="80px" align="right" />
      <el-table-column label="最低" prop="low" width="80px" align="right" />
      <el-table-column label="最高" prop="high" width="80px" align="right" />
      <el-table-column label="成交量" prop="vol" width="90px" align="right" :sort-method="customVolSort" sortable />
      <el-table-column label="持仓量" prop="opi" width="90px" align="right" :sort-method="customOpiSort" sortable />
      <el-table-column label="增仓" prop="opiChg" width="80px" align="right" sortable />
      <el-table-column label="前结" prop="preSett" width="80px" align="right" />
      <el-table-column label="前收" prop="preClose" width="80px" align="right" />
      <el-table-column label="趋势度" prop="trend" width="100px" align="right" sortable/>
      <el-table-column label="振幅" prop="amplitude" width="80px" align="right" :sort-method="customAmplitudeSort" sortable/>
      <el-table-column label="成交额" prop="turnover" width="90px" align="right" :sort-method="customTurnoverSort" sortable/>
    </el-table>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http, httpNoLoading } from '../util/http'
import { bigNumberTransform, formatDecimalPoint, isMarketTime } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      subTabDataList: [{ label: '全部', name: 'all' }],
      favoritesSubTab: [{ label: '全部', name: 'all' }],
      mainSubTab: [{ label: '全部', name: 'all' },
      { label: '贵金属', name: 'gjs' },
      { label: '有色金属', name: 'ysjs' },
      { label: '黑色系', name: 'hs' },
      { label: '化工', name: 'hg' },
      { label: '能源', name: 'ny' },
      { label: '油脂油料', name: 'yzyl' },
      { label: '农产品', name: 'ncp' }],
      shfeSubTab: [{ label: '主力', name: 'main' }, { label: '全部', name: 'all' }],
      dceSubTab: [{ label: '主力', name: 'main' }, { label: '全部', name: 'all' }],
      czceSubTab: [{ label: '主力', name: 'main' }, { label: '全部', name: 'all' }],
      ineSubTab: [{ label: '主力', name: 'main' }, { label: '全部', name: 'all' }],
      gfexSubTab: [{ label: '主力', name: 'main' }, { label: '全部', name: 'all' }],
      category: 'favorites',
      categorySub: 'all',
      dataList: [],
      timer: null
    })

    // 自选对话框关闭后传来的事件处理
    vueEvent.on('favoritesDialogClose', (flag) => {
      // 自动跳转到自选页面
      obj.category = 'favorites'
      obj.categorySub = 'all'
      obj.subTabDataList = [{ label: '全部', name: 'all' }]
      handleFavoritesDialogClose()
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '1')
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderTab()
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      clearInterval(obj.timer)
      vueEvent.off('favoritesDialogClose', () => { })
    })

    // 渲染画面
    const renderTab = () => {
      // 是否存在缓存
      if (store.state.marketData === '') {
        // 无缓存，从后台请求数据
        let formData = new FormData()
        formData.append("category", "obj_list")
        http({
          url: `/contract`,
          method: 'post',
          data: formData
        }).then((res) => {
          console.log(res)
          res.data.data[0].forEach((item) => {
            item['label'] = item['name']
            item['name'] = item['symbol']
          })
          res.data.data[1].forEach((item) => {
            item['label'] = item['name']
            item['name'] = item['symbol']
          })
          res.data.data[2].forEach((item) => {
            item['label'] = item['name']
            item['name'] = item['symbol']
          })
          res.data.data[3].forEach((item) => {
            item['label'] = item['name']
            item['name'] = item['symbol']
          })
          res.data.data[4].forEach((item) => {
            item['label'] = item['name']
            item['name'] = item['symbol']
          })
          obj.shfeSubTab = obj.shfeSubTab.concat(res.data.data[0])
          obj.dceSubTab = obj.dceSubTab.concat(res.data.data[1])
          obj.czceSubTab = obj.czceSubTab.concat(res.data.data[2])
          obj.ineSubTab = obj.ineSubTab.concat(res.data.data[3])
          obj.gfexSubTab = obj.gfexSubTab.concat(res.data.data[4])
        })
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 渲染画面
    const renderView = () => {
      requestData()
      clearInterval(obj.timer)
      obj.timer = setInterval(function () {
        // 如不在开盘时间，则停止获取数据
        if (!isMarketTime()) {
          clearInterval(obj.timer)
          return
        }
        // 获取最新行情数据
        requestData(false)
      }, 60000) // 每60秒刷新数据
    }

    // 获取合约列表
    const requestData = (isLoading = true) => {
      let formData = new FormData()
      formData.append("category", obj.category + "_" + obj.categorySub)
      formData.append("dataSource", "db")
      if (isLoading) {
        http({
          url: `/market`,
          method: 'post',
          data: formData
        }).then((res) => {
          console.log(res)
          processData(res.data.data)
          setStore()
        }).catch((err) => {
          clearInterval(obj.timer)
        })
      } else {
        httpNoLoading({
          url: `/market`,
          method: 'post',
          data: formData
        }).then((res) => {
          processData(res.data.data)
          setStore()
        }).catch((err) => {
          clearInterval(obj.timer)
        })
      }
    }

    // 加工处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        if (item.chgPct !== "-") {
          item.chgPct = (item.chgPct * 100).toFixed(2) + '%'
          item.volForSort = parseFloat(item.vol)
          item.opiForSort = parseFloat(item.opi)
          item.vol = bigNumberTransform(parseFloat(item.vol))
          item.opi = bigNumberTransform(parseFloat(item.opi))
          item.chg = formatDecimalPoint(parseFloat(item.chg), item.symbol)
          item.close = formatDecimalPoint(parseFloat(item.close), item.symbol)
          item.open = formatDecimalPoint(parseFloat(item.open), item.symbol)
          item.low = formatDecimalPoint(parseFloat(item.low), item.symbol)
          item.high = formatDecimalPoint(parseFloat(item.high), item.symbol)
          item.preSett = formatDecimalPoint(parseFloat(item.preSett), item.symbol)
          item.preClose = formatDecimalPoint(parseFloat(item.preClose), item.symbol)
          item.trend = parseFloat(item.trend.toFixed(2))
          item.amplitude = (item.amplitude * 100).toFixed(2) + '%'
          item.turnoverForSort = parseFloat(item.turnover)
          item.turnover = bigNumberTransform(parseFloat(item.turnover))
        }
        item.no = no
        no++
      })
      obj.dataList = data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'subTabDataList': obj.subTabDataList,
        'favoritesSubTab': obj.favoritesSubTab,
        'mainSubTab': obj.mainSubTab,
        'shfeSubTab': obj.shfeSubTab,
        'dceSubTab': obj.dceSubTab,
        'czceSubTab': obj.czceSubTab,
        'ineSubTab': obj.ineSubTab,
        'gfexSubTab': obj.gfexSubTab,
        'category': obj.category,
        'categorySub': obj.categorySub,
        // 'dataList': obj.dataList,
        // 'date': obj.date,
      }
      store.commit('setMarketData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.subTabDataList = store.state.marketData.subTabDataList
      obj.favoritesSubTab = store.state.marketData.favoritesSubTab
      obj.mainSubTab = store.state.marketData.mainSubTab
      obj.shfeSubTab = store.state.marketData.shfeSubTab
      obj.dceSubTab = store.state.marketData.dceSubTab
      obj.czceSubTab = store.state.marketData.czceSubTab
      obj.ineSubTab = store.state.marketData.ineSubTab
      obj.gfexSubTab = store.state.marketData.gfexSubTab
      obj.category = store.state.marketData.category
      obj.categorySub = store.state.marketData.categorySub
      // obj.dataList = store.state.marketData.dataList
      // obj.date = store.state.marketData.date
    }

    // tab点击事件
    const handleTabClick = (tab) => {
      obj.category = tab.props.name
      if (obj.category === 'favorites') {
        obj.subTabDataList = obj.favoritesSubTab
        obj.categorySub = 'all'
      } else if (obj.category === 'main') {
        obj.subTabDataList = obj.mainSubTab
        obj.categorySub = 'all'
      } else if (obj.category === 'shfe') {
        obj.subTabDataList = obj.shfeSubTab
        obj.categorySub = 'main'
      } else if (obj.category === 'dce') {
        obj.subTabDataList = obj.dceSubTab
        obj.categorySub = 'main'
      } else if (obj.category === 'czce') {
        obj.subTabDataList = obj.czceSubTab
        obj.categorySub = 'main'
      } else if (obj.category === 'ine') {
        obj.subTabDataList = obj.ineSubTab
        obj.categorySub = 'main'
      } else if (obj.category === 'gfex') {
        obj.subTabDataList = obj.gfexSubTab
        obj.categorySub = 'main'
      }
      renderView()
    }

    // subTab点击事件
    const handleSubTabClick = (tab) => {
      obj.categorySub = tab.props.name
      renderView()
    }

    // 按钮打开自选
    const handleFavorites = (e) => {
      vueEvent.emit('favoritesDialogVisible', true)
    }

    // 自选对话框关闭后的回调方法
    const handleFavoritesDialogClose = (e) => {
      renderView()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      // console.log(row.name)
      const name = row.name
      store.commit('setCurrentContract', row.name)
      router.push(`/candlestick?name=${name}`)
      // router.push({ name: 'domestic', params: { name }})
    }

    // 表格排序(文字型的数字列)
    const customStrSort = (a, b) => {
      return parseFloat(a.chg) - parseFloat(b.chg)
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customVolSort = (a, b) => {
      return a.volForSort - b.volForSort
    }

    // 表格排序(带金额单位的数字列)
    const customOpiSort = (a, b) => {
      return a.opiForSort - b.opiForSort
    }

    // 表格排序(带百分号的数字列)
    const customAmplitudeSort = (a, b) => {
      return parseFloat(a.amplitude.replace('%', '')) - parseFloat(b.amplitude.replace('%', ''))
    }

     // 表格排序(带金额单位的数字列)
     const customTurnoverSort = (a, b) => {
      return a.turnoverForSort - b.turnoverForSort
    }

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.open > row.row.preSett && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.open < row.row.preSett && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.low > row.row.preSett && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.low < row.row.preSett && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.high > row.row.preSett && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.high < row.row.preSett && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.close > row.row.preSett && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.close < row.row.preSett && row.columnIndex === 3) {
        return { color: 'green' }
      }
      if (row.row.trend > 0 && row.columnIndex === 14) {
        return { color: 'red' }
      } else if (row.row.trend < 0 && row.columnIndex === 14) {
        return { color: 'green' }
      }
    }

    return {
      obj,
      store,
      handleTabClick,
      handleSubTabClick,
      handleFavorites,
      handleRowClick,
      customStrSort,
      customPctSort,
      customVolSort,
      customOpiSort,
      customAmplitudeSort,
      customTurnoverSort,
      cellStyle
    }
  }

}
</script>
<style lang="scss"></style>
